import { FC } from 'react';

import CommunicationDataSection from './CommunicationDataSection';
import CommunicationAttachmentsSection from './CommunicationAttachementsSection';
import CommunicationRecipientsSection from './CommunicationRecipientsSection';
import CommunicationInvalidRecipientsSection from './CommunicationInvalidRecipientsSection';

const CommunicationBody: FC = () => (
  <div className="nk-ibx-reply-group">
    <div className="nk-ibx-reply-item nk-reply-item">
      <CommunicationDataSection />

      <hr className="divider" />

      <CommunicationAttachmentsSection />

      <hr className="divider" />

      <CommunicationRecipientsSection />

      <hr className="divider" />

      <CommunicationInvalidRecipientsSection />
    </div>
  </div>
);

export default CommunicationBody;
